import React, { Component } from 'react';
import styles from './Web3Info.module.scss';

export default class Web3Info extends Component {
  renderNetworkName(networkId) {
    switch (networkId) {
      case 3:
        return 'Ropsten';
      case 4:
        return 'Rinkeby';
      case 1:
        return 'Main';
      case 42:
        return 'Kovan';
      default:
        return 'Private';
    }
  }

  render() {
    const { networkId, isMetaMask } = this.props;
    return (
      <div className={styles.web3}>
        <h3> Web3 connection info </h3>
        <div className={styles.dataPoint}>
          <div className={styles.label}>Network:</div>
          <div className={styles.value}>
            {networkId} - {this.renderNetworkName(networkId)}
          </div>
        </div>
        <div className={styles.dataPoint}>
          <div className={styles.label}>Using Metamask:</div>
          <div className={styles.value}>{isMetaMask ? 'YES' : 'NO'}</div>
        </div>
      </div>
    );
  }
}
